function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M333.314,0H81.464C68.464,0,57.891,10.568,57.891,23.573V81.39H28.939 c-12.999,0-23.578,10.574-23.578,23.578V338.68c0,13.005,10.579,23.573,23.578,23.573h21.696h282.679 c12.999,0,23.578-10.568,23.578-23.573V23.573C356.892,10.568,346.308,0,333.314,0z M21.677,338.674V104.969 c0-4.003,3.263-7.261,7.261-7.261h28.952V338.68c0,4.003-3.258,7.256-7.256,7.256H28.939 C24.941,345.93,21.677,342.683,21.677,338.674z M340.575,338.674c0,4.003-3.258,7.256-7.261,7.256H73.066 c0.174-0.544,0.267-1.115,0.402-1.681c0.103-0.419,0.218-0.827,0.305-1.256c0.261-1.409,0.435-2.839,0.435-4.319V89.549V23.573 c0-4.003,3.258-7.256,7.256-7.256h251.85c4.003,0,7.261,3.253,7.261,7.256V338.674z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.557,69.707H115.001c-4.504,0-8.159,3.655-8.159,8.159c0,4.504,3.655,8.159,8.159,8.159 h188.556c4.509,0,8.159-3.655,8.159-8.159C311.716,73.362,308.066,69.707,303.557,69.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.557,113.22H115.001c-4.504,0-8.159,3.655-8.159,8.159s3.655,8.159,8.159,8.159h188.556 c4.509,0,8.159-3.655,8.159-8.159S308.066,113.22,303.557,113.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.557,156.732H115.001c-4.504,0-8.159,3.655-8.159,8.159s3.655,8.159,8.159,8.159h188.556 c4.509,0,8.159-3.655,8.159-8.159S308.066,156.732,303.557,156.732z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.557,200.245H115.001c-4.504,0-8.159,3.655-8.159,8.159s3.655,8.159,8.159,8.159h188.556 c4.509,0,8.159-3.655,8.159-8.159S308.066,200.245,303.557,200.245z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.557,243.757H115.001c-4.504,0-8.159,3.655-8.159,8.159c0,4.504,3.655,8.159,8.159,8.159 h188.556c4.509,0,8.159-3.655,8.159-8.159C311.716,247.412,308.066,243.757,303.557,243.757z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.557,287.27H115.001c-4.504,0-8.159,3.655-8.159,8.159c0,4.504,3.655,8.159,8.159,8.159 h188.556c4.509,0,8.159-3.655,8.159-8.159C311.716,290.925,308.066,287.27,303.557,287.27z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.253 362.253",
    style: {
      "enableBackground": "new 0 0 362.253 362.253"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/open-text-page.8a454e69.svg";
export { SvgComponent as ReactComponent };